<template>
  <v-form
    ref="form"
    v-model="valid"
  >
    <v-row dense>
      <v-col
        v-for="(item, i) in roles"
        :key="i"
        cols="12"
      >
        <v-checkbox
          v-model="selected"
          :value="item.roleId"
          :label="item.roleName"
          hide-details
        />
      </v-col>
      <v-col
        cols="12"
        class="mt-4"
      >
        <v-btn
          block
          :loading="saving"
          @click="save"
        >
          Save
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'UserCardRoles',
  data: () => {
    return {
      valid: false,
      selected: [],
      saving: false
    };
  },
  computed: {
    ...mapGetters({ user: 'users/user', roles: 'lookup/roles' })
  },
  mounted() {
    this.setSelected();
  },
  methods: {
    setSelected() {
      this.selected = this.user.roleIds;
    },
    save() {
      if (!this.$refs.form.validate()) return;

      this.saving = true;
      this.$store
        .dispatch('users/saveRoles', {
          userId: this.user.id,
          roleIds: this.selected
        })
        .then(() => {
          this.$root.$snackbarSuccess('Roles saved');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
